import { action, makeAutoObservable, observable } from 'mobx'

export class DownloadState {    
  @observable
  selectedRowKeys: React.Key[] = [] // 已选择的资料ID列表
  @action
  setSelectedRowKeys(selectedRowKeys: React.Key[]) {
    console.error('selectedRowKeys changed:', selectedRowKeys)
    this.selectedRowKeys = selectedRowKeys
  }

  constructor() {
    makeAutoObservable(this)
  }

  
}
